module.exports = __webpack_public_path__ + "6fa237e445933da53523cc0df0fd01de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/footerlogo2.jpg
// module id = 440
// module chunks = 0